// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"937bd915","112":"d7dd0b25","211":"b2a1d4b7","311":"594d483a","424":"ca85a700","448":"ba979046","527":"7d90d926","612":"2846a587","744":"1aec0f42","764":"59fae911","844":"1c7c9342","919":"3886885a","975":"c92c95fc"}[chunkId] + ".chunk.js";
};